<template>
  <div class="row">
    <!-- control panel card -->
    <div class="col-md-6">
      <ControlPanel :url="siteWorxUrl" :status="siteWorxStatus" />
    </div>

    <!-- phpmyadmin card -->
    <div class="col-md-6">
      <PhpMyAdmin :url="phpMyAdminUrl" :status="phpMyAdminStatus" />
    </div>
  </div>
</template>

<script>
import { computed, onMounted } from "@vue/composition-api";
import ControlPanel from "@/components/smart/cards/ControlPanel";
import PhpMyAdmin from "@/components/smart/cards/PhpMyAdmin";
import store from "@/store";

export default {
  name: "PlanControlPanelPage",
  components: { PhpMyAdmin, ControlPanel },
  setup() {
    const site = computed(() => store.getters["plans/getPrimarySite"]);
    const siteWorxUrl = computed(() => store.getters["sites/getSiteWorxUrl"]);
    const phpMyAdminUrl = computed(() => store.getters["sites/getPhpMyAdminUrl"]);
    const siteWorxStatus = computed(() => store.getters["sites/getSiteWorxUrlStatus"]);
    const phpMyAdminStatus = computed(() => store.getters["sites/getPhpMyAdminUrlStatus"]);

    onMounted(() => {
      store.dispatch("sites/getSiteWorxUrl", site.value.id);
      store.dispatch("sites/getPhpMyAdminUrl", site.value.id);
    });

    return {
      siteWorxStatus,
      phpMyAdminStatus,
      siteWorxUrl,
      phpMyAdminUrl,
    };
  },
};
</script>
